var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "sign-in-form" }, [
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _c("h1", [_vm._v(_vm._s(_vm.$t("signInConnectedAccountPage.title")))]),
        _c("div", { staticClass: "description" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("signInConnectedAccountPage.description")) + " "
          ),
        ]),
        _c("text-field", {
          staticClass: "input",
          attrs: {
            type: "email",
            label: _vm.$t("signInConnectedAccountPage.emailLabel"),
          },
          model: {
            value: _vm.email,
            callback: function ($$v) {
              _vm.email = $$v
            },
            expression: "email",
          },
        }),
        _c("text-field", {
          staticClass: "input",
          attrs: {
            type: "password",
            label: _vm.$t("signInConnectedAccountPage.passwordLabel"),
          },
          model: {
            value: _vm.password,
            callback: function ($$v) {
              _vm.password = $$v
            },
            expression: "password",
          },
        }),
        _c("div", { staticClass: "attention" }, [
          _vm._v(
            _vm._s(_vm.$t("signInConnectedAccountPage.passwordRequirement"))
          ),
        ]),
        _c(
          "div",
          { staticClass: "sign-in-container" },
          [
            _c("p", { staticClass: "sign-in-txt" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("signInConnectedAccountPage.agreementText")) +
                  " "
              ),
              _c("a", { attrs: { href: "/terms", target: "_blank" } }, [
                _vm._v(
                  _vm._s(_vm.$t("signInConnectedAccountPage.termsOfService"))
                ),
              ]),
              _vm._v(_vm._s(_vm.$t("signInConnectedAccountPage.and"))),
              _c("a", { attrs: { href: "/privacy", target: "_blank" } }, [
                _vm._v(
                  _vm._s(_vm.$t("signInConnectedAccountPage.privacyPolicy"))
                ),
              ]),
              _vm._v(
                _vm._s(
                  _vm.$t("signInConnectedAccountPage.agreementTextSuffix")
                ) + " "
              ),
            ]),
            _c("button-default", { staticClass: "login-button" }, [
              _vm._v(_vm._s(_vm.$t("signInConnectedAccountPage.loginButton"))),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm.message
      ? _c("div", { domProps: { innerHTML: _vm._s(_vm.message) } })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }